import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Panel } from 'react-bootstrap';

import Section from './website_section';
import SectionDropzone from './section_dropzone';
import { reorderableList } from 'helpers/react_dnd/reorderable_list';

export class WebsiteSectionList extends React.Component {
  static propTypes = {
    onEditSection: PropTypes.func.isRequired,
    onDeleteSection: PropTypes.func.isRequired,
    onReorder: PropTypes.func,
    defaultLayout: PropTypes.bool,
    disabled: PropTypes.bool,
    location: PropTypes.string.isRequired,
    sections: PropTypes.array.isRequired,
    targetGroup: PropTypes.string,
    sectionTypes: PropTypes.array.isRequired,
    layout: PropTypes.string.isRequired
  };

  dropTargetCollector = connect => (
    { connectDropTarget: connect.dropTarget() }
  );

  hasSections() {
    return this.props.sections.length > 0;
  }

  noSectionsSelectedMessage = () => {
    if (this.props.defaultLayout) {
      let text = 'Using default layout.';
      if (!this.props.disabled) {
        text += '  Add a section to customize.';
      }
      return text;
    } else {
      return 'No sections selected.';
    }
  };

  isInvalidLayout(section) {
    const sectionType = _.find(this.props.sectionTypes, type => type.key === section.sectionType);
    return sectionType.validLayouts && !_.includes(sectionType.validLayouts, this.props.layout);
  }

  render() {
    const panelClass = classNames({
      'website-section-list': true,
      'empty-list': !this.hasSections()
    });
    return (
      <Panel key={this.props.location} className={panelClass}>
        <Panel.Body>
          <div className="section-list">
            {this.renderSections()}
            {this.renderListEndDropzone()}
          </div>
        </Panel.Body>
      </Panel>
    );
  }

  renderListEndDropzone() {
    if (this.hasSections()) {
      return (
        <SectionDropzone
          index={this.props.sections.length - 1}
          listName={this.props.location}
          onReorder={this.props.onReorder}
          targetGroup={this.props.targetGroup}
        />
      );
    }
  }

  renderSections() {
    if (this.props.sections.length > 0) {
      const sections = this.props.sections.map((section, index) => {
        if (this.isInvalidLayout(section)) return null;
        return (
          <Section
            disabled={this.props.disabled}
            key={section.id}
            section={section}
            index={index}
            listName={this.props.location}
            onDelete={this.props.onDeleteSection}
            onEdit={this.props.onEditSection}
            onReorder={this.props.onReorder}
            targetGroup={this.props.targetGroup}
          />
        );
      });
      return <ul>{sections}</ul>;
    } else {
      return (
        <SectionDropzone
          index={-1}
          listName={this.props.location}
          onReorder={this.props.onReorder}
          targetGroup={this.props.targetGroup}
        >
          <div className="no-sections text-muted h4">{this.noSectionsSelectedMessage()}</div>
        </SectionDropzone>
      );
    }
  }
}

export default reorderableList(WebsiteSectionList);
